
import React from 'react';
import { useAuth } from '@/providers/AuthProvider';
import { Link } from 'react-router-dom';
import MainNav from '@/components/MainNav';
import ProfileSection from '@/components/account/ProfileSection';
import SubscriptionSection from '@/components/account/SubscriptionSection';
import InstallationsSection from '@/components/account/InstallationsSection';

const AccountPage = () => {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-secondary/20">
      <header className="border-b">
        <MainNav currentPath="account" />
      </header>

      <main className="container max-w-6xl mx-auto px-4 py-12">
        <div className="space-y-8">
          <div className="space-y-2">
            <h1 className="text-3xl font-bold tracking-tight">Account</h1>
            <p className="text-muted-foreground">
              Manage your account settings and view your installations
            </p>
          </div>

          <div className="grid gap-8">
            <ProfileSection userId={user.id} />
            <SubscriptionSection userId={user.id} />
            <InstallationsSection userId={user.id} />
          </div>
        </div>
      </main>
    </div>
  );
};

export default AccountPage;
